import { Switch, Redirect, Route } from 'react-router-dom'
import GateGateway from 'containers/entrance/GateGateway'
import Registration from 'containers/forms/Registration'
import SubWarehouse from 'containers/Warehouse/SubMenu'
import PaymentStatus from 'containers/PaymentStatus'
import OrderContract from 'containers/OrderContract'
import NewWarehouse from 'containers/NewWarehouse'
import FirstOpening from 'containers/FirstOpening'
import OrderDetails from 'containers/OrderDetails'
import OrderSummary from 'containers/OrderSummary'
import Contract from 'containers/forms/Contract'
import Shared from 'containers/entrance/Shared'
import Billing from 'containers/forms/Billing'
import MapDetails from 'containers/MapDetails'
import Categories from 'containers/Categories'
import Warehouses from 'containers/Warehouses'
import Warehouse from 'containers/Warehouse'
import MapSearch from 'containers/MapSearch'
import Dashboard from 'containers/Dashboard'
import Google from 'containers/OAuth/Google'
import Apple from 'containers/OAuth/Apple'
import Reset from 'containers/forms/Reset'
import StartPage from 'layouts/StartPage'
import Payment from 'containers/Payment'
import Account from 'containers/Account'
import Login from 'containers/Login'
import Chats from 'containers/Chats'
import Shop from 'containers/Shop'
import Home from 'containers/Home'
import Maps from 'containers/Maps'
import Help from 'containers/Help'
import MRoute from './MRoute'

const Router = () => {
  return (
    <Switch>
      <MRoute exact path='/' bottomBar>
        <StartPage />
      </MRoute>

      <MRoute exact path={['/account/:key/:action', '/account/:key', '/account']} bottomBar>
        <Account />
      </MRoute>

      <MRoute exact path='/categories' darkHeader animation={false}>
        <Categories />
      </MRoute>

      <MRoute exact path={['/chat/:id', '/chat']}>
        <Chats />
      </MRoute>

      <MRoute exact path='/contract' protectedPath>
        <Contract />
      </MRoute>

      <MRoute exact path='/dashboard' bottomBar>
        <Dashboard />
      </MRoute>

      <Route exact path={['/firstopening/:id/:key', '/firstopening/:id']}>
        <FirstOpening />
      </Route>

      <MRoute exact path='/help' bottomBar>
        <Help />
      </MRoute>

      <MRoute exact path='/home' bottomBar>
        <Home />
      </MRoute>

      <MRoute exact path='/login'>
        <Login />
      </MRoute>

      <MRoute exact path='/login/reset'>
        <Reset />
      </MRoute>

      <MRoute exact path={['/map/:placeId', '/map']} flyingHeader>
        <Maps />
      </MRoute>

      <Route exact path={['/mapsearch/:provinceIdx/:cityIdx', '/mapsearch/:provinceIdx', '/mapsearch']}>
        <MapSearch />
      </Route>

      <MRoute exact path='/mapdetails/:placeId' whiteHeader darkHeader animation={false}>
        <MapDetails />
      </MRoute>

      <Route exact path={['/newwarehouse/:key/:id', '/newwarehouse/:key', '/newwarehouse']}>
        <main>
          <NewWarehouse />
        </main>
      </Route>

      <Route exact path='/oauth/apple'>
        <main>
          <Apple />
        </main>
      </Route>

      <Route exact path='/oauth/goggle'>
        <main>
          <Google />
        </main>
      </Route>

      <MRoute exact path='/order/billing' protectedPath>
        <Billing />
      </MRoute>

      <MRoute exact path='/order/contract' protectedPath>
        <OrderContract />
      </MRoute>

      <MRoute exact path='/order/payment' protectedPath>
        <Payment />
      </MRoute>

      <MRoute exact path='/order/summary' protectedPath>
        <OrderSummary />
      </MRoute>

      <MRoute exact path='/order/:id' darkHeader roundedHeader>
        <OrderDetails />
      </MRoute>

      <MRoute exact path={['/order/:cartId/equipment/:equipmentId/:categoryId', '/order/:cartId/equipment/:equipmentId', '/order/:cartId/shop/:categoryId', '/order/:cartId/shop', '/shop/:warehouseId', '/shop']} darkHeader animation={false}>
        <Shop />
      </MRoute>

      <MRoute exact path='/payment/status' protectedPath>
        <PaymentStatus />
      </MRoute>

      <MRoute exact path='/registration'>
        <Registration />
      </MRoute>

      <MRoute exact path='/shared/:hash'>
        <Shared />
      </MRoute>

      <MRoute exact path='/warehouses' animation={false} protectedPath>
        <Warehouses />
      </MRoute>

      <MRoute exact path='/warehouses/:id' animation={false} protectedPath>
        <Warehouse />
      </MRoute>

      <MRoute exact path={['/warehouses/:id/gate', '/warehouses/:id/gateway']} animation={false} protectedPath>
        <GateGateway />
      </MRoute>

      <MRoute exact path={['/warehouses/:id/:type/:action/:typeId', '/warehouses/:id/:type/:action', '/warehouses/:id/:type']} animation={false} protectedPath>
        <SubWarehouse />
      </MRoute>

      <Redirect to='/' />
    </Switch>
  )
}

export default Router